import { requestIntercomSegmentationInfoWithCache, undefinedToNull } from 'shared-assets/lib/sdk/intercom'
import getPracticeProperties, { getCompanyTypeName } from 'shared-assets/lib/sdk/practiceProperties'
import { getPatientPopDemoUrl } from 'shared-assets/lib/sdk/patientpop'
import Providers from 'shared-assets/lib/sdk/providers'
import kUserService from 'shared-assets/lib/sdk/kUserService';
import sharedConfig from 'shared-assets/src/config-environments/config'
APP_ID = sharedConfig.intercom;

angular.module('kareo.ui.shared.modules.intercom', ['kareo.ui.shared.modules.data', 'kareo.ui.shared.modules.authentication.k-roles'])
.service 'intercom',
  ['authenticatedUser', 'practice', 'K_ROLES', '$q', (authenticatedUser, practice, K_ROLES, $q) ->

    @loadIntercom = () ->

      `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
      return window.Intercom

    

      #load intercom
    @loadIntercom()

    intercom = {}
    intercom.prepare = () ->
      return unless !intercom.isMock

      intercomRequestedData =
        appID: APP_ID
        requestList: [
          authenticatedUser.get,
          practice.get,
          getPracticeProperties,
          kUserService.getCurrentUser,
          Providers.getAllProviders.bind(Providers)
        ]
        mappingResponsesToSegmentationInfo: ([user, practice, practiceProperties, currentUser, providers]) ->
          if(!user || !practice || !practiceProperties || !currentUser)
            return null;
          
          segmentation = {
            email: user?.email,
            userId: user?.pmUserId,
            pmEnabled: practice?.pmenabled,
            isJointCustomer: practiceProperties?.isPatientPopPartnerActive,
            companyType: getCompanyTypeName(practiceProperties?.companyType),
            practiceSpecialty: practiceProperties?.practiceSpecialty,
            pricingFamily: practiceProperties?.editionType?.caption,
            hasBillingProduct: currentUser?.providerInfo?.products?.PM,
            hasClinicalProduct: currentUser?.providerInfo?.products?.KAREO_EHR,
            hasEngageProduct: currentUser?.providerInfo?.products?.KAREO_OFFICE,
            hasTelehealthProduct: currentUser?.providerInfo?.products?.KAREO_TELEHEALTH,
            isSystemAdministrator: currentUser?.roles?.includes(K_ROLES.ADMIN),
            isProvider: currentUser?.roles?.includes(K_ROLES.PROVIDER),
            isClinicalAssistant: currentUser?.roles?.includes(K_ROLES.CLINICAL_ASSISTANT),
            isOfficeStaff: currentUser?.roles?.includes(K_ROLES.OFFICE_STAFF),
            isBiller: currentUser?.roles?.includes(K_ROLES.BILLER),
            isBusinessManager: currentUser?.roles?.includes(K_ROLES.BUSINESS_MANAGER),
            userType: if currentUser?.roles?.includes(K_ROLES.PROVIDER) then 'Provider' else 'Non-Provider',
            user,
            practice,
            providerCount: !!providers && Array.isArray(providers) && providers.length
          };
          return segmentation;

      requestIntercomSegmentationInfoWithCache(intercomRequestedData)
      .then (segmentationInfo) ->
        if(!!segmentationInfo)
          settings =
            app_id: segmentationInfo.appId,
            demoUrl: getPatientPopDemoUrl(segmentationInfo),
            email: segmentationInfo.email,
            user_id: segmentationInfo.userId,
            pmenabled: segmentationInfo.pmEnabled,
            lastApplication: segmentationInfo.lastApplicationName,
            lastSeenPlatform_at: segmentationInfo.lastSeenPlatformDate, #date must end in _at,
            isJointCustomer: segmentationInfo.isJointCustomer,
            companyType: segmentationInfo.companyType,
            practiceSpecialty: segmentationInfo.practiceSpecialty || null,
            pricingFamily: segmentationInfo.pricingFamily,
            hasBillingProduct: undefinedToNull(segmentationInfo.hasBillingProduct),
            hasClinicalProduct: undefinedToNull(segmentationInfo.hasClinicalProduct),
            hasEngageProduct: undefinedToNull(segmentationInfo.hasEngageProduct),
            hasTelehealthProduct: undefinedToNull(segmentationInfo.hasTelehealthProduct),
            System_Administrator: Number(undefinedToNull(segmentationInfo.isSystemAdministrator)),
            Provider: Number(undefinedToNull(segmentationInfo.isProvider)),
            Clinical_Assistant: Number(undefinedToNull(segmentationInfo.isClinicalAssistant)),
            Office_Staff: Number(undefinedToNull(segmentationInfo.isOfficeStaff)),
            Biller: Number(undefinedToNull(segmentationInfo.isBiller)),
            Business_Manager: Number(undefinedToNull(segmentationInfo.isBusinessManager)),
            user_type: segmentationInfo.userType
          intercom.init(settings)

    intercom.init = (settings) ->
      window.Intercom 'boot', settings

    if @isMock
      intercom.isMock = true

    return intercom
  ]
